import { FC } from "react";
import styled from "styled-components";
import { Button } from "components/atoms/Button";
import { QUOTE_BUTTON_ID } from "../../utils/_constants";

const IS_LIVE = false;

export const BlogGetAQuoteButton: FC<React.PropsWithChildren<{}>> = () => {
  const handleClick = () => {
    document.getElementById(QUOTE_BUTTON_ID)?.click();
  };

  if (!IS_LIVE) {
    return null;
  }

  return (
    <ButtonContainer>
      <Button onClick={handleClick}>Get a quote</Button>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  text-align: left;
  margin-top: 1rem;
`;
